export default __webpack_public_path__ + "static/media/1_RIVER_BEIGE_120X278_265.e15fef07.jpg";